import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CustomersTicketsCountService } from 'src/app/services/customersTicketsCount/customersTicketsCount.service';

@Component({
    selector: 'app-customersTicketsCount-card',
    templateUrl: './customersTicketsCount-card.component.html',
    styleUrls: ['./customersTicketsCount-card.component.scss'],
})
export class CustomersTicketsCountCardComponent implements OnInit {

    // This is the Behavior you will reference in the HTML
    customersTicketsCount$ = new BehaviorSubject<string | undefined>(undefined);

    constructor(
        private _customersTicketsCountService: CustomersTicketsCountService
    ) {

    }

    ngOnInit() {
        this._customersTicketsCountService.getCustomersTicketsCount$().subscribe(result => {
            this.customersTicketsCount$.next(result.scalar);
        });
    }
}
